import { IUser } from "@/interfaces";
import { IUserSearchInfo } from "@/interfaces/User/IUserSearchInfo";
import { useGetUserQuery } from "@/services";
import { Popover } from "antd";
import { ReactNode } from "react";
import { UserInfoCard } from "./UserInfoCard";

interface IProps {
  user: IUser | IUserSearchInfo;
  children: ReactNode;
}

export const UserInfoWrapper = ({ user, children }: IProps) => {
  const { data: userInfo, isLoading } = useGetUserQuery(user?.id, {
    skip: !user?.id || !!(user as IUserSearchInfo)?.username,
  });

  if (isLoading) return null;

  if (!user) return children;

  return (
    <Popover
      content={<UserInfoCard user={(userInfo || user) as IUserSearchInfo} />}
    >
      <div className="w-fit">{children}</div>
    </Popover>
  );
};
